import React from "react";
import { Box, Grid } from "@mui/material";
import Shimmer from "./Shimmer";

export const OrderCardShimmer: React.FC = () => (
  <Box sx={{ p: 2, border: "1px solid #eee", borderRadius: 1 }}>
    <Shimmer height="24px" width="60%" /> {/* Order number */}
    <Box sx={{ mt: 2 }}>
      <Shimmer height="16px" width="40%" /> {/* Customer name */}
    </Box>
    <Box sx={{ mt: 2 }}>
      <Shimmer height="16px" width="30%" /> {/* Status */}
    </Box>
    <Box sx={{ mt: 2 }}>
      <Shimmer height="16px" width="100%" /> {/* Product details */}
      <Shimmer height="16px" width="90%" sx={{ mt: 1 }} />
    </Box>
  </Box>
);

export const OrderListShimmer: React.FC = () => (
  <Box
    sx={{
      opacity: 1,
      transition: "opacity 0.3s ease-in-out",
    }}
  >
    <Grid container spacing={2}>
      {[1, 2, 3].map((i) => (
        <Grid item xs={12} key={i}>
          <Box
            sx={{
              p: 2,
              border: "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: 1,
              mb: 2,
            }}
          >
            <Shimmer height="24px" width="60%" /> {/* Order number */}
            <Box sx={{ mt: 2 }}>
              <Shimmer height="16px" width="40%" /> {/* Customer name */}
            </Box>
            <Box sx={{ mt: 2 }}>
              <Shimmer height="16px" width="30%" /> {/* Status */}
            </Box>
            <Box sx={{ mt: 2 }}>
              <Shimmer height="16px" width="100%" /> {/* Product details */}
              <Shimmer height="16px" width="90%" sx={{ mt: 1 }} />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export const ProductDetailsShimmer: React.FC = () => (
  <Box
    sx={{
      opacity: 1,
      transition: "opacity 0.3s ease-in-out",
    }}
  >
    <Shimmer height="32px" width="70%" /> {/* Product name */}
    <Box sx={{ mt: 3 }}>
      <Shimmer height="20px" width="40%" /> {/* Category */}
    </Box>
    <Box sx={{ mt: 3 }}>
      <Shimmer height="100px" width="100%" /> {/* Description */}
    </Box>
    <Grid container spacing={2} sx={{ mt: 2 }}>
      {[1, 2, 3].map((i) => (
        <Grid item xs={4} key={i}>
          <Shimmer height="150px" width="100%" /> {/* Product images */}
        </Grid>
      ))}
    </Grid>
  </Box>
);

export const DashboardStatsShimmer: React.FC = () => (
  <Box
    sx={{
      opacity: 1,
      transition: "opacity 0.3s ease-in-out",
    }}
  >
    <Grid container spacing={3}>
      {[1, 2, 3, 4].map((i) => (
        <Grid item xs={12} sm={6} md={3} key={i}>
          <Box
            sx={{
              p: 2,
              border: "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: 1,
            }}
          >
            <Shimmer height="24px" width="60%" />
            <Box sx={{ mt: 2 }}>
              <Shimmer height="32px" width="40%" />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);
